<template>
  <div>
    <multiselect
        :options="apps" selectedLabel="ausgewählt"
        selectLabel="auswählen"
        v-model="app"
        placeholder="App auswählen" label="name" @select="setFbConfig"
        :close-on-select="true"
        :searchable="false"></multiselect>
    <div class="chatWrapper" v-if="$store.state.chat.app">
      <vue-toastr ref="mytoast"></vue-toastr>
      <AdminWarning :isAdmin="isAdmin"></AdminWarning>
      <tabs @changed="tabChanged" :options="{ defaultTabHash: this.tabs.allChats }">
        <div class="topbar" v-if="showFilter">
          <template>
            <Customersearch v-if="!isAdmin" @error="setError" @success="setSuccess" :client-id="clientId">
            </Customersearch>
          </template>
          <Chatfilter @error="setError"
                      @success="setSuccess"
                      @filter="applyFilter"
                      :groups="clientGroups"></Chatfilter>
        </div>
        <tab :id="tabs.allChats" name="Eingang (Gesamt) - Chats: "
             prefix="<i class='fa fa-comments-o' aria-hidden='true' style='margin-right: 10px'></i>"
             :suffix="allClientMessagesCount">
          <div class="container-fluid">
            <div class="row">
              <div class="col-12">
                <ChatsOverview :isAdmin="isAdmin" @error="setError" @success="setSuccess"
                               :keywords="keywords" :userId="userId"
                               :userName="userName" :clientId="clientId"
                               :userGroups="userGroups" :clientGroups="clientGroups"
                               ref="chatOverview"></ChatsOverview>
              </div>
            </div>
          </div>
        </tab>
        <tab v-if="!isAdmin" :id="tabs.userChats" name="Meine Chats - Chats: "
             prefix="<i class='fa fa-envelope' aria-hidden='true' style='margin-right: 10px'></i>"
             :suffix="chatAgentChatsCount">
          <ChatsOverviewUser @error="setError" @success="setSuccess" :userId="userId" :userName="userName"
                             :clientId="clientId" :userGroups="userGroups"
                             :clientGroups="clientGroups" :chatTemplates="chatTemplates"></ChatsOverviewUser>
        </tab>
      </tabs>
    </div>
  </div>
</template>

<script>

import ChatsOverview from "../components/ChatsOverview";
import ChatsOverviewUser from "../components/ChatsOverviewUser";
import Chatfilter from "../components/Chatfilter";
import Customersearch from "../components/Customersearch";
import VueToastr from "vue-toastr";
import AdminWarning from '../components/AdminWarning';
import 'firebase/storage';     // for storage
import Multiselect from 'vue-multiselect';

import {
  addDoc,
  collection,
  CollectionReference,
  doc,
  DocumentData,
  DocumentReference,
  enableIndexedDbPersistence,
  Firestore,
  getDoc,
  getDocs,
  initializeFirestore,
  query,
  setDoc,
  where,
  getFirestore,
  onSnapshot,
  orderBy
} from 'firebase/firestore';
import {FirebaseApp, initializeApp, getApp} from 'firebase/app';
import {getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut} from "firebase/auth";

// This import loads the firebase namespace along with all its type information.
import fb from '../firebase/init';
import {Tab, Tabs} from 'vue-tabs-component';
import {mapActions} from 'vuex';

export default {
  name: "Chat",
  props: ["name", "userId", "userName", "userEmail", "isAdmin", "clientId", "originalClientId", "originalUserId", "userGroups", "clientGroups", "chatTemplates", "apps"],
  components: {
    ChatsOverview,
    ChatsOverviewUser,
    Tab,
    Tabs,
    Multiselect,
    Chatfilter,
    Customersearch,
    VueToastr,
    AdminWarning
  },
  data() {
    return {
      app: null,
      showChat: false,
      current: false,
      currentChat: null,
      currentClientChat: false,
      isHidden: true,
      groupOverlay: false,
      colleagueOverlay: false,
      appliedStatusFilter: null,
      oldCount: null,
      newCount: null,
      keywords: "",
      timeIntervalLowerLimit: 1,
      timeIntervalUpperLimit: 0,
      hasSearchResult: false,
      hasFilter: false,
      errors: false,
      success: false,
      errorMsg: "",
      successMsg: "",
      customerId: "",
      fullEmployeeName: "",
      allClientMessagesWithSearchcriteria: [],
      allGroupMessages: [],
      allMessages: [],
      watchedMessages: [],
      groupToFilter: null,
      currentTab: null,
      collection: null,
      tabs: {
        allChats: 'all',
        userChats: 'user'
      },
      chatStates: {
        all: 'all',
        open: 'open',
        closed: 'closed',
        processed: 'processed'
      },
      chats: {
        allChats: [],
        agentChats: [],
        agentWatchedChats: []
      }
    };
  },
  methods: {
    ...mapActions({
      changeApp: 'changeApp',
      setFirebaseConfig: 'setFbConfig',
      getUserChats: 'getUserChats',
      getAllClientChats: 'getAllClientChats'
    }),
    async setFbConfig(app) {
      var firebaseConfig = {
        apiKey: app.fb_api_key,
        authDomain: app.fb_auth_domain,
        databaseURL: app.fb_database_url,
        projectId: app.fb_project_id,
        storageBucket: app.fb_storage_bucket,
        messagingSenderId: app.fb_messaging_sender_id,
        appId: app.fb_app_id,
      };

      const configCredentials = {
        userId: this.userId,
        clientId: this.clientId,
        userEmail: this.userEmail,
        originalClientId: this.originalClientId,
        originalUserId: this.originalUserId,
        isAdmin: this.isAdmin
      };

      this.setFirebaseConfig({firebaseConfig: firebaseConfig, configCredentials: configCredentials})
    },
    containsObject(obj, list) {
      var i;
      for (i = 0; i < list.length; i++) {
        if (list[i].id === obj) {
          return true;
        }
      }
      return false;
    },
    tabChanged(selectedTab) {
      this.errors = false;
      this.currentTab = selectedTab.tab.id;
    },
    setError: function (msg) {
      this.$refs.mytoast.e(msg);
    },
    setSuccess: function (msg) {
      this.$refs.mytoast.s(msg);
    },
    reloadChats: function () {
      this.getAllClientChats();
      this.getUserChats({userId: this.userId});
    },
    applyFilter: function (filterOptions) {
      const data = filterOptions.data;
      switch (filterOptions.filter) {
        case 'group':
          this.groupToFilter = data;
          break;
        case 'date':
          this.$store.commit('setTimeIntervalLowerLimit', data.low)
          this.$store.commit('setTimeIntervalUpperLimit', data.high)
          this.getAllClientChats();
          break;
        case 'status':
          this.appliedStatusFilter = data;
          break;
        case 'search':
          if (data.keywords.length) {
            this.hasSearchResult = true;
            this.keywords = data.keywords;
          } else {
            this.hasSearchResult = false;
          }
          break;
        default:
          break;
      }
      this.filterClientMessages();
    },
    filterClientMessages: function () {
      let filteredMessages = this.$store.getters.getOriginalClientMessages;

      if (this.hasSearchResult) {
        filteredMessages = filteredMessages.filter(message => message.fullCustomerName.toLowerCase().indexOf(this.keywords.toLowerCase()) !== -1);
      }
      if (this.appliedStatusFilter && this.appliedStatusFilter !== 'all') {
        filteredMessages = filteredMessages.filter(chat => chat.status === this.appliedStatusFilter);
      }
      if (this.groupToFilter) {
        filteredMessages = filteredMessages.filter(chat => chat.groupId === this.groupToFilter.id);
      }
      this.$store.commit('setAllClientMessages', filteredMessages);
    }
  },
  computed: {
    fireApp () {
      return this.$store.getters.getFireApp
    },
    allClientMessages: function () {
      return this.$store.getters.getAllClientMessages;
    },
    allChatAgentMessages: function () {
      return this.$store.getters.getAllChatAgentMessages;
    },
    allWatchedMessagesByChatAgent: function () {
      return this.$store.getters.getAllWatchedMessagesByChatAgent;
    },
    allClientMessagesCount: function () {
      return this.allClientMessages.length;
    },
    chatAgentChatsCount: function () {
      return this.allChatAgentMessages.length + this.allWatchedMessagesByChatAgent.length;
    },
    showFilter: function () {
      return this.currentTab && this.currentTab === this.tabs.allChats;
    }
  },
  mounted() {
    if (this.$refs.mytoast) {
      this.$refs.mytoast.defaultPosition = "toast-top-right";
    }
  },
  watch:{
    fireApp(value) {
      let that = this;
      Object.values(this.apps).forEach(function(app) {
        console.log(value._options)
        if (app.fb_app_id == value._options.appId) {
          that.app = app;
        }
      })
    }
  }
};

</script>

<style lang="scss">

@import "~vue-multiselect/dist/vue-multiselect.min.css";

.multiselect__option--selected {
  background: #42B886;

  &.multiselect__option--highlight {
    background: #42B886;

    &:after {
      background: #42B886;
    }

  }
}

.multiselect__option--highlight {
  &:after {
    background-color: #8b8b8b;
    color: #fff;
  }

  background-color: #8b8b8b;
  color: #fff;
}


.chat h2 {
  font-size: 2.6em;
  margin-bottom: 0px;
}

.chat h5 {
  margin-top: 0px;
  margin-bottom: 40px;
}

/* Fade in tabs */
@-webkit-keyframes fadeEffect {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeEffect {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}


.chatIteam {
  background-color: #fff;
  opacity: 0.8;
}

.tabs-component {
  margin: 4em 0;
}

.tabs-component-tabs {
  border: solid 1px #ddd;
  border-radius: 6px;
  margin-bottom: 5px;
}

@media (min-width: 700px) {
  .tabs-component-tabs {
    border: 0;
    align-items: stretch;
    display: flex;
    justify-content: flex-start;
    margin-bottom: -1px;
  }
}

.tabs-component-tab {
  color: #999;
  font-size: 14px;
  font-weight: 600;
  margin-right: 0;
  list-style: none;
}

.tabs-component-tab:not(:last-child) {
  border-bottom: dotted 1px #ddd;
}

.tabs-component-tab:hover {
  color: #666;
}

.tabs-component-tab.is-active {
  color: #000;
}

.tabs-component-tab.is-disabled * {
  color: #cdcdcd;
  cursor: not-allowed !important;
}

@media (min-width: 700px) {
  .tabs-component-tab {
    background-color: #fff;
    border: solid 1px #ddd;
    border-radius: 3px 3px 0 0;
    margin-right: .5em;
    transform: translateY(2px);
    transition: transform .3s ease;
  }

  .tabs-component-tab.is-active {
    border-bottom: solid 1px #fff;
    transform: translateY(0);
  }
}

.tabs-component-tab-a {
  align-items: center;
  color: inherit;
  display: flex;
  padding: .75em 1em;
  text-decoration: none;
}

.tabs-component-panels {
  padding: 4em 0;
}

@media (min-width: 700px) {
  .tabs-component-panels {
    border-top-left-radius: 0;
    background-color: #fff;
    border: solid 1px #ddd;
    border-radius: 0 6px 6px 6px;
    box-shadow: 0 0 10px rgba(0, 0, 0, .05);
    padding: 4em 2em;
    padding: 4em 2em;
  }
}

.topbar {
}

.adminWarning {
  display: flex;
  flex-direction: column;
  height: 100px;
  border-radius: 7px;
  margin: 15px 0 0 0;
  color: #fff;
  justify-content: space-evenly;
  align-items: center;

  p {
    width: 90%;

  }

}
</style>
